/* eslint-disable react/no-did-mount-set-state */
import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import queryString from 'query-string';
import i18n from '../../utils/i18n';
import { trackMealCardAuthSuccess } from '../../actions/tracking/mealCards';

import Dialog from '../../components/Dialog';

const VERIFIED_ISSUERS = ['edenred'];

export class MealCardDialog extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showDialog: false,
      headerTitle: '',
      message: '',
    };

    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    const params = queryString.parse(window.location.search);
    const { statusMessage, header } = this.filterQueryParams(params);

    if (statusMessage) {
      this.setState(
        {
          showDialog: true,
          headerTitle: header,
          message: statusMessage,
        },
        () => {
          delete params.status;
          delete params.balance;
          delete params.issuer;

          const url = `${window.location.pathname}?${queryString.stringify(params)}`;
          window.history.replaceState(null, null, url);
        },
      );
    }
  }

  verifyIssuer(issuer) {
    return VERIFIED_ISSUERS.includes(issuer.toLowerCase()) && issuer;
  }

  filterQueryParams(params) {
    const { trackMealCardAuth } = this.props;
    const { status, balance, issuer: untrustedIssuer } = params;
    const issuer = untrustedIssuer && this.verifyIssuer(untrustedIssuer);
    let statusMessage = '';
    let header = '';

    if (status === 'success_available' && issuer && balance) {
      header = i18n.gettext('ticketrestaurant_modal_success_title %(value)s', { value: issuer });
      statusMessage = i18n.gettext('ticketrestaurant_modal_success_message %(value)s', {
        value: balance,
      });
      trackMealCardAuth({ name: `Added ${issuer} with allowance`, tr_event_id: 5, issuer });
    } else if (status === 'success_no_allowance' && issuer) {
      header = i18n.gettext('ticketrestaurant_modal_success_title %(value)s', { value: issuer });
      statusMessage = i18n.gettext('ticketrestaurant_modal_success_noallowanceleft');
      trackMealCardAuth({ name: `Added ${issuer} with no allowance`, tr_event_id: 6, issuer });
    } else if (status === 'success_unavailable_day' && issuer) {
      header = i18n.gettext('ticketrestaurant_modal_success_title %(value)s', { value: issuer });
      statusMessage = i18n.gettext('ticketrestaurant_modal_success_nonworkingday');
      trackMealCardAuth({ name: `Added ${issuer} invalid day`, tr_event_id: 7, issuer });
    } else if (status === 'failed') {
      header = i18n.gettext('Failed');
      statusMessage = i18n.gettext('Something went wrong.');
    }

    return { statusMessage, header };
  }

  handleClose() {
    this.setState({ showDialog: false });
  }

  render() {
    const { showDialog, headerTitle, message } = this.state;

    return (
      <Dialog
        isOpen={showDialog}
        onClose={this.handleClose}
        headerTitle={headerTitle}
        message={message}
      />
    );
  }
}

MealCardDialog.propTypes = {
  trackMealCardAuth: PropTypes.func.isRequired,
};

export default connect(
  null,
  (dispatch) => ({
    trackMealCardAuth: (data) => dispatch(trackMealCardAuthSuccess(data)),
  }),
)(MealCardDialog);
